import 'ez-plus';
import 'flatpickr';
import lity from 'lity';
import moment from 'moment';
import PerfectScrollbar from 'perfect-scrollbar';
import cart from './_cart';

const $itemImg = $('img.img-fluid');
const $itemImgGallery = $('.item-image-gallery');
const $template = $('#template');

const PRODUCT = $template.data('product');

$itemImg.ezPlus({
    responsive: true,
    easing: true,
    zoomType: 'window',
    cursor: 'pointer',
    zIndex: 2,
    gallerySelector: '.item-image-gallery',
    galleryActiveClass: 'active',
    zoomWindowFadeIn: 200,
    zoomWindowFadeOut: 200,
    zoomWindowPosition: '.item-details-description',
    zoomWindowWidth: $('.item-details-description').width(),
    zoomWindowHeight: $('.item-details-description').height(),
    containLensZoom: true,
    zoomWindowOffsetX: 15,
    loadingIcon: $itemImg.data('loadingicon'),
    respond: [
        {
            range: '100-768',
            enabled: false,
            showLens: false,
            zoomWindowPosition: '#zoomMobileContainer',
        },
    ],
});

$itemImg.on('click.lity', function () {
    lity($(this).data('zoom-image'));
});

if ($itemImgGallery.length) {

    $itemImgGallery.on('click', 'a', function () {

        // Try to center the active thumbnail image scrolling
        const $thumb = $(this);
        const $scrollContainer = $thumb.parents('.item-image-gallery');
        const scrollContainerTotalWidth = $scrollContainer.get(0).scrollWidth;
        const scrollContainerVisibleWidth = $scrollContainer.width();
        const currentScrollPosition = $scrollContainer.scrollLeft();
        const thumbLeft = $thumb.position().left + currentScrollPosition;
        const thumbWidth = $thumb.outerWidth();
        const scrollLeft = thumbLeft - (scrollContainerVisibleWidth - (scrollContainerTotalWidth / 2)) - (thumbWidth / 2);
        $scrollContainer.animate({
            scrollLeft,
        }, 200);


        const url = $(this).data('zoom-image');

        // Re-assign the lity event for the new active image
        $itemImg
            .off('click.lity')
            .on('click.lity', function () {
                lity(url);
            });

        // Manage the active classes on the thumbnails
        $('.item-image-gallery > a').removeClass('active');
        $(this).addClass('active');

        // Set caption
        const caption = $(this).data('caption');
        $('.item-image-caption > p').html(caption || '&nbsp;');
    });

    /* eslint no-unused-vars: 0 */
    // Initialize the custom scrollbar
    const ps = new PerfectScrollbar('.item-image-gallery', {
        wheelSpeed: 2,
        useBothWheelAxes: true,
        suppressScrollY: true,
    });

}

function addToCart({
    eventid = null,
}) {
    const itemid = $(this).data('itemid');
    const qty = +$('#ddlQty').val();
    const btnHtml = $(this).html();
    const btnWidth = $(this).width();
    $(this)
        .prop('disabled', true)
        .attr('aria-disabled', true)
        .width(btnWidth)
        .html('<i class="fas fa-spinner fa-pulse fa-fw"></i>');
    cart.add(itemid, qty, {
        eventid,
    })
        .then(() => {
            $(this)
                .html(btnHtml)
                .prop('disabled', false)
                .attr('aria-disabled', false);
        });
}

/**
 * Tradeshow
 */
const tradeshow = {
    $dateInput: $('#tradeshow-date-select'),
    $addToCartBtn: $('#tradeshow-add-to-cart'),
    $qtyBtn: $('#ddlQty'),
    fp() {
        return tradeshow.$dateInput.flatpickr({
            dateFormat: 'm/d/Y',
            mode: 'range',
            onMonthChange: tradeshow.loadCurrentMonth,
            onYearChange: tradeshow.loadCurrentMonth,
            onOpen: tradeshow.loadCurrentMonth,
            onChange(dates) {
                if (dates.length > 1) {
                    const maxDays = $template.data('tradeshowmaxdays');
                    const moments = dates.map(i => moment(i));
                    if (moments[1].diff(moments[0], 'days') > maxDays) {
                        toast.error(`You may only check out an item for ${maxDays} days at a time.`);
                        tradeshow.fp.clear();
                        dates.length = 0;
                    }
                }
                tradeshow.$addToCartBtn
                    .prop('disabled', dates.length !== 2)
                    .attr('aria-disabled', dates.length !== 2);
            },
        });
    },
    loadCurrentMonth(e) {
        const start = moment().month(this.currentMonth).year(this.currentYear);
        const startdate = start.startOf('month').format('MM/DD/YYYY');
        const enddate = start.endOf('month').format('MM/DD/YYYY');
        const $spinner = $(`
            <div class="calendar-spinner">
                <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.8);"></div>
                <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; width: 100%;">
                    <i class="fas fa-spinner fa-pulse fa-fw fa-3x"></i>
                    <h6 class="w-100 mt-2">Retrieving Calendar...</h6>
                </div>
            </div>
        `);
        if (!$('.flatpickr-calendar .calendar-spinner').length) {
            $('.flatpickr-calendar').append($spinner);
        }
        $.get(`./ordering/items/${PRODUCT}/reserve/${encodeURIComponent(startdate)}-${encodeURIComponent(enddate)}?quantity=${+tradeshow.$qtyBtn.val()}`)
            .done(response => {
                if (response.success) {
                    tradeshow.fp.set('disable', response.calendar.filter(i => !i.orderable).map(i => i.Date));
                    $spinner.remove();
                }
            })
            .fail((xhr, stat, err) => {
                console.error(err);
                toast.error(err);
            });
    },
    addReservation() {
        const dateRange = tradeshow.$dateInput.val();
        const eventid = $(this).data('eventid') || null;
        const isRange = dateRange.includes(' to ');
        const startdate = dateRange.split(' to ')[0];
        const enddate = isRange ? dateRange.split(' to ')[1] : startdate;
        const btnHtml = $(this).html();
        const btnWidth = $(this).width();
        $(this)
            .prop('disabled', true)
            .attr('aria-disabled', true)
            .width(btnWidth)
            .html('<i class="fas fa-spinner fa-pulse fa-fw"></i>');
        $.post(`./ordering/items/${PRODUCT}/reserve/${encodeURIComponent(startdate)}-${encodeURIComponent(enddate)}`, {
            eventid,
            quantity: tradeshow.$qtyBtn.val(),
        })
            .done(response => {
                if (response.success) {
                    $(this)
                        .prop('disabled', false)
                        .attr('aria-disabled', false)
                        .html(btnHtml)
                        .attr('data-eventid', response.eventid);
                    addToCart.call(tradeshow.$addToCartBtn, {
                        eventid: response.eventid,
                    });
                }
            })
            .fail((xhr, stat, err) => {
                console.error(err);
                toast.error(err);
                $(this)
                    .prop('disabled', false)
                    .attr('aria-disabled', false)
                    .html(btnHtml);
            });
    },
    handleQuantityChange(e) {
        tradeshow.fp.clear();
    },
    init() {
        tradeshow.fp = tradeshow.fp();
        tradeshow.$addToCartBtn.on('click', tradeshow.addReservation);
        tradeshow.$qtyBtn.on('change', tradeshow.handleQuantityChange);
    },
};
if (tradeshow.$dateInput.length) {
    tradeshow.init();
}


$('[data-toggle="tooltip"]').tooltip();
$('#add-to-cart').on('click', addToCart);
